// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_1wI0O","imageLink":"_1AbSv","fadeOutImage":"_2682S","image":"_2Z2ro"};